import { render, staticRenderFns } from "./SyncDataMonitor.vue?vue&type=template&id=73b7e641&scoped=true"
import script from "./SyncDataMonitor.vue?vue&type=script&lang=js"
export * from "./SyncDataMonitor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b7e641",
  null
  
)

export default component.exports